import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import { TableProps } from "./Table.interface"
import { CardBody } from "reactstrap";

const TableRecord = <T extends keyof T>({ data, columns }: TableProps<T>): JSX.Element => {
    return (
        <CardBody>
            <div className="table-responsive">
                <table className="table mb-0">
                    <TableHeader columns={columns} />
                    <TableBody data={data} columns={columns} />
                </table>
            </div>
        </CardBody>
    )
}
export default TableRecord;